import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router';
import './Footer.css'

class Footer extends Component {
	render() {
		return (
			<footer className={"footer " + this.props.className}>
				<Grid>					
					<Row>
						<Col xs={12}>
							<ul>
								<li>
									<Link to="/terms">Terms</Link>
								</li>
								<li>
									<Link to="/privacy">Privacy</Link>
								</li>
								<li className="copyright">
									<Link to="/">&copy; Webfinery</Link>
								</li>
							</ul>
						</Col>						
					</Row>
				</Grid>
	        </footer>
        )
	}
}

export default Footer;


// WEBPACK FOOTER //
// ./src/footer/Footer.js